import a from "react";
import { getIconColor as d } from "./iconfont.es5470.js";
import p from "./iconfont.es5471.js";
const r = {
  display: "block"
}, f = ({ size: e = 16, useVw: t, useRem: l, color: h, withColor: n, removeClassName: c, disableSSR: i, style: o, ...m }) => {
  const v = o ? { ...r, ...o } : r;
  return /* @__PURE__ */ a.createElement(p, { disableSSR: i }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "24px-Web3", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: t ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (l ? "rem" : "px"), height: t ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (l ? "rem" : "px"), className: c ? "" : "iconpark-icon", style: v, fill: "none", ...m }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: c ? "" : "24px-Web3"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: c ? "" : "normal",
        fill: n ? d(h, 0, "#262933") : "#262933",
        datafollowfill: n ? d(h, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M3.743 14.748a8.674 8.674 0 0 1-.438-2.448h3.89c.023.975.155 1.947.396 2.897a.8.8 0 1 0 1.55-.394 11.373 11.373 0 0 1-.345-2.503h6.409a11.366 11.366 0 0 1-.35 2.513.8.8 0 0 0 1.55.396c.244-.954.377-1.93.4-2.909h3.766a.804.804 0 0 0 .124-.01 8.675 8.675 0 0 1-.453 2.503.8.8 0 0 0 1.516.513c.352-1.039.542-2.151.542-3.306 0-5.689-4.611-10.3-10.3-10.3C6.311 1.7 1.7 6.31 1.7 12c0 1.135.184 2.229.524 3.252a.8.8 0 1 0 1.519-.505ZM10.437 3.44a8.707 8.707 0 0 0-7.04 7.26h3.86a12.834 12.834 0 0 1 3.18-7.26Zm4.697 7.26H8.866A11.24 11.24 0 0 1 12 4.109a11.239 11.239 0 0 1 3.134 6.591Zm5.437 0h-3.828a12.834 12.834 0 0 0-3.18-7.26 8.707 8.707 0 0 1 7.04 7.26h-.032Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M2.079 17.742a.185.185 0 0 1 .176-.242h.898c.08 0 .152.052.176.13l.849 2.692.894-2.695a.185.185 0 0 1 .176-.127h.88c.08 0 .152.053.176.13l.853 2.719.884-2.721a.185.185 0 0 1 .176-.128h.805c.125 0 .215.123.176.242L7.905 21.73a.278.278 0 0 1-.264.193h-.934a.278.278 0 0 1-.265-.195l-.785-2.498-.821 2.501a.278.278 0 0 1-.264.192h-.936a.278.278 0 0 1-.264-.193l-1.293-3.987Zm8.884 2.405v.808h2.126c.102 0 .185.083.185.185v.596a.185.185 0 0 1-.185.186h-3.087a.278.278 0 0 1-.277-.278v-3.866c0-.154.124-.278.277-.278h3.005c.102 0 .185.083.185.185v.596a.185.185 0 0 1-.185.185h-2.044v.746h1.779c.102 0 .185.083.185.185v.564a.185.185 0 0 1-.185.186h-1.78Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M14.246 17.5a.278.278 0 0 0-.278.278v3.866c0 .153.125.278.278.278h2.11c.594 0 1.044-.106 1.352-.316a1.03 1.03 0 0 0 .467-.897c0-.257-.065-.474-.196-.65a1.159 1.159 0 0 0-.537-.411 1.598 1.598 0 0 0-.082-.032c.177-.095.316-.215.417-.36.122-.173.183-.373.183-.6a.986.986 0 0 0-.43-.834c-.286-.215-.72-.322-1.3-.322h-1.984Zm2.009 3.518h-1.049v-.897h1.049c.215 0 .377.038.486.114.114.072.17.183.17.335a.382.382 0 0 1-.17.34c-.11.072-.271.108-.486.108Zm-1.049-1.762v-.853h.86c.21 0 .368.036.473.108.105.067.158.172.158.315a.365.365 0 0 1-.158.323c-.105.071-.263.107-.474.107h-.859Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M20.073 22.01a3.84 3.84 0 0 1-.922-.114 2.98 2.98 0 0 1-.65-.24.175.175 0 0 1-.073-.233l.29-.599c.049-.1.175-.135.275-.083a2.295 2.295 0 0 0 1.043.258c.214 0 .385-.04.511-.12a.381.381 0 0 0 .19-.34.361.361 0 0 0-.158-.31c-.105-.08-.278-.12-.518-.12h-.524v-.79l.79-.853h-1.559a.185.185 0 0 1-.185-.185v-.596c0-.102.083-.185.185-.185h2.826c.102 0 .185.083.185.185v.598l-.911.984c.289.058.523.166.703.324.286.244.429.56.429.947 0 .253-.07.49-.208.714-.135.223-.344.406-.626.55-.282.138-.646.208-1.093.208Z"
        }
      )
    )
  )));
}, g = f;
export {
  g as default
};
